<template>
    <svg width="120" height="30" viewBox="0 0 1210 276" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="scale(.47265625)">
            <rect width="512" height="512" :fill="color || ' url(#a)'" rx="67" :class="goAnimation ? 'ball' : ''" />
            <rect width="192.036" height="35.229" x="159.82" y="101" :fill="fill || '#fff'" rx="16.455"
                :class="goAnimation ? 'ball' : ''" />
            <rect width="51.121" height="220.642" x="196.108" y="145.897" :fill="fill || '#fff'" rx="23.878"
                :class="goAnimation ? 'ball' : ''" />
            <rect width="51.121" height="220.642" x="264.71" y="145.897" :fill="fill || '#fff'" rx="23.878"
                :class="goAnimation ? 'ball' : ''" />
            <rect width="192.036" height="35.229" x="159.82" y="376.207" :fill="fill || '#fff'" rx="16.455"
                :class="goAnimation ? 'ball' : ''" />
        </g>
        <!-- Прекрасная старая версия. RIP. -->
        <!-- <rect y="17" width="242" height="242" rx="31" :fill="color || 'url(#paint0_linear_806_95065)'" v-if="goAnimation"
            class="ball" />
        <rect y="17" width="242" height="242" rx="31" :fill="color || 'url(#paint0_linear_806_95065)'"
            v-if="!goAnimation" />
        <circle cx="181" cy="78" r="30" :fill="fill || '#fff'" v-if="goAnimation" class="ball" />
        <circle cx="181" cy="78" r="30" :fill="fill || '#fff'" v-if="!goAnimation" />
        <circle cx="61" cy="198" r="30" :fill="fill || '#fff'" v-if="goAnimation" class="ball" />
        <circle cx="61" cy="198" r="30" :fill="fill || '#fff'" v-if="!goAnimation" /> -->
        <path v-if="!this.collapsed" id="logo-text" style='transform: translateY(-3%)'
            d="M429.75 130.18C439.87 132.633 447.307 136.773 452.06 142.6C456.967 148.273 459.42 155.787 459.42 165.14C459.42 193.813 436.957 208.15 392.03 208.15C378.843 208.15 365.35 207.767 351.55 207L353.16 162.84L351.55 58.88L404.22 58.65C419.4 58.65 431.207 61.87 439.64 68.31C448.073 74.5967 452.29 83.72 452.29 95.68C452.29 103.653 450.297 110.63 446.31 116.61C442.477 122.59 436.957 127.113 429.75 130.18ZM420.32 99.82C420.32 93.0733 418.327 88.32 414.34 85.56C410.353 82.6467 403.377 81.19 393.41 81.19H382.14L381.45 121.44L403.07 122.13C408.897 120.597 413.19 118.067 415.95 114.54C418.863 111.013 420.32 106.107 420.32 99.82ZM397.32 185.84C406.98 185.84 414.417 183.923 419.63 180.09C424.997 176.257 427.68 170.737 427.68 163.53C427.68 152.643 420.627 145.897 406.52 143.29L380.99 143.75L380.76 160.08L381.45 184.92C386.817 185.533 392.107 185.84 397.32 185.84ZM486.508 172.5L485.128 91.31L514.798 89.7L512.728 163.07H514.798L561.028 90.62H592.078L590.698 169.74L591.618 207H562.408L563.788 172.5L564.018 134.32H561.948L515.488 207H485.128L486.508 172.5ZM700.521 93.15L698.911 115.23L675.451 113.62H668.781L668.091 169.74L669.011 207H640.261L641.411 172.5L640.951 113.62H634.281L610.361 115.23L608.521 112.93L610.131 90.85H698.911L700.521 93.15ZM768.193 90.62C781.38 90.62 791.5 93.7633 798.553 100.05C805.607 106.183 809.133 115.077 809.133 126.73C809.133 140.223 804.457 151.033 795.103 159.16C785.75 167.287 773.253 171.35 757.613 171.35H745.883L747.033 207H718.053L719.203 172.5L718.053 90.85L768.193 90.62ZM762.903 150.65C768.27 148.963 772.257 146.433 774.863 143.06C777.47 139.687 778.773 135.163 778.773 129.49C778.773 123.663 777.087 119.293 773.713 116.38C770.493 113.467 765.433 111.857 758.533 111.55L747.033 112.01L746.343 149.96L762.903 150.65ZM831.283 172.5L829.903 91.31L859.573 89.7L857.503 163.07H859.573L905.803 90.62H936.853L935.473 169.74L936.393 207H907.183L908.563 172.5L908.793 134.32H906.723L860.263 207H829.903L831.283 172.5ZM1074.93 169.74L1076.08 207H1047.1L1048.25 172.5L1048.02 161.23L1022.03 161L998.799 161.46L998.569 169.74L999.719 207H970.739L971.889 172.5L970.739 90.85H1000.18L999.259 136.85L1023.87 137.31L1047.79 137.08L1047.1 90.85H1076.54L1074.93 169.74ZM1207.05 207H1177.84L1174.62 190.21L1172.55 183.54L1149.09 183.31L1128.39 183.77L1126.78 188.6L1123.33 207H1095.04L1135.75 90.85H1170.02L1207.05 207ZM1166.34 161.69L1153.23 117.3H1151.39L1135.98 161.69L1150.93 161.92L1166.34 161.69Z"
            :fill="color || '#3D3D3D'" />
        <defs>
            <!-- <linearGradient id="paint0_linear_806_95065" x1="242" y1="17" x2="0" y2="259" gradientUnits="userSpaceOnUse">
                <stop stop-color="#1C386B" />
                <stop offset="1" stop-color="#3B71D6" />
            </linearGradient> -->
            <linearGradient id="a" x1="0" x2="512" y1="512" y2="0" gradientUnits="userSpaceOnUse">
                <stop stop-color="#006DD4" />
                <stop offset="1" stop-color="#003873" />
            </linearGradient>
        </defs>
    </svg>
</template>
<style>
@keyframes hideshow {
    0% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

@keyframes mymove {
    0% {
        -webkit-transform: scale(1) rotate(60deg);
        transform-origin: 200px center;
    }

    50% {
        -webkit-transform: scale(0.6) rotate(320deg);
        transform-origin: 200px center;
    }

    100% {
        transform: scale(1) rotate(720deg);
        transform-origin: 200px center;
    }
}

.ball {
    animation: mymove 2s infinite;
}

path {
    animation: hideshow 0.6s ease;
}
</style>
<script>
export default {
    name: 'LogoSVG',
    props: {
        load: {
            type: Boolean,
            default: false,
        },
        collapsed: {
            type: Boolean
        },
        color: {
            type: String
        },
        fill: {
            type: String
        }
    },
    data() {
        return {
            goAnimation: false,
        }
    },
    watch: {
        loadState: {
            handler(n, o) {
                if (this.goAnimation === true) this.goAnimation = false;
                this.goAnimation = true;
                setTimeout(() => this.goAnimation = false, 2000);
            }
        }
    },
    computed: {
        loadState() {
            return this.$store.getters["getLoadState"];
        },
    }
}
</script>